module.exports = __webpack_public_path__ + "img/AD4.fd16953c.png";